import apiClient from '@shared/api/apiClient';

/**
 * 결재라인 등록
 *
 * 서버 규격에 따라 `column`(역할_순번)과 `values`(값_순서)는
 * 쉼표(,)로 연결된 문자열이며, 상호 순서와 개수가 반드시 일치해야 합니다.
 *
 * @param {Object} params
 * @param {number} params.enumber - 결재라인 소유자 사번
 * @param {number} params.company - 회사 코드
 * @param {string} params.title - 결재라인 명칭
 * @param {string} params.column - 역할 컬럼 목록 (CSV 형태 / 예: sign_1,sign_1_order...)
 * @param {string} params.values - 컬럼 매핑 값 목록 (CSV 형태 / 예: 12345,1...)
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function saveSignLine({ enumber, company, title, column, values }) {
  const response = await apiClient.post(
    '/v1/sign-lines',
    {
      enumber,
      company,
      title,
      column,
      values,
    },
    {
      withAuth: true,
    },
  );
  return response.data;
}

/**
 * 결재라인 리스트 가져오기
 */
async function signLineList() {
  const response = await apiClient.get('/v1/sign-lines', {
    withAuth: true,
  });
  return response.data;
}

/**
 * 결재라인 상세 조회
 *
 * @param {number} signLineId - 결재라인 고유 ID
 * @param {boolean} [toHtml=false] - HTML 변환 여부 (기본값 false)
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function getSignLineInfo(signLineId, toHtml = false) {
  const response = await apiClient.get(`/v1/sign-lines/${signLineId}`, {
    params: {
      toHtml,
    },
    withAuth: true,
  });

  return response.data;
}

/**
 * 결재라인 수정 API
 *
 * @param {number} idx - 수정할 결재라인 ID
 * @param {string} setValue
 *   UPDATE문 SET 절에 그대로 삽입되는 문자열.
 *   예) "sign_1=123, sign_1_order=1, title='test'"
 *
 *  문자열이 그대로 SQL에 반영되므로 값 구성 시 주의가 필요함.
 */
async function signLineModify({ idx, setValue }) {
  const response = await apiClient.put(
    '/v1/sign-lines',
    { idx, setValue },
    {
      withAuth: true,
    },
  );
  return response.data;
}
/**
 * 결재라인 삭제 API
 */
async function signLineRemove({ idx }) {
  const response = await apiClient.delete(`/v1/sign-lines/${idx}`, {
    withAuth: true,
  });
  return response.data;
}
export { saveSignLine, signLineList, getSignLineInfo, signLineModify, signLineRemove };
